import { ɵNoopAnimationStyleNormalizer } from "@angular/animations/browser";
import { GroupModel } from "src/app/admin/models/group.model";
import { SurveyModel } from "src/app/dashboard/dashboard.model";
import { QuestionViewModel } from "src/app/shared/models/questionview.model";
import { UserActivityLogModel } from "src/app/shared/models/userActivityLog.model";

export class CreateEntity {
    entityId: string;  
    entityID: string;  
    entityName: string;  
    entityDescription: string;  
    createdDate:Date;
    entityGroupId: string; 
    entityGroupName: string; 
    userActivityLog? : UserActivityLogModel;
    entityGroupMappings :EntityGroupMapping[];
    entityFields:EntityField[];
    entityStatus : string;
    logoFormat: string = "";
    logoImage: string = "";
    logoSize:number;
    groupMasterModel: GroupModel[]=[];
    surveyModel : SurveyModel;
    surveyId:string;
    entityGroupMappingRel :EntityGroupMapping;
    entityGroupRelModel :EntityGroupRelModel;
    //isLookUp :boolean= false;
    showInAdvSecurity:boolean = false;
  }
  
  export class EntityGroupMapping {
    entityID: string; 
    groupId: string;
    isOwner: boolean;
    groupMasterId: string;  
  }
  export class EntityGroupRelModel {
    entityID: string; 
    groupId: string;  
    groupName:string;
  }
  
  export class EntityField {
    entityId: string; 
    entityFieldID :string;
    entityFieldName: string;
    typeId :number; 
    isSearchable :boolean;
    isDisplay :boolean;
    isAutoGenerated :boolean;
    fieldProperties : FieldPropertyRelation[];  
    errorMessage:string;
    questionMasters :QuestionViewModel;
    disableField: boolean = false;
  }
  
  export class TypeMaster{
    typeId:number;
    typeName :string;
  }

  export class PropertyMaster{
    propertyId : number;
    propertyName :string;
    propertyDataType :string;
  }

  export class FieldPropertyRelation{
    entityFieldId:string;
    propertyId : number;
    propertyValue :string;
    propertyDetails : PropertyMaster;
  }
